import React, { useState } from 'react';
import classnames from 'classnames';
import { ReactSVG } from 'react-svg';
import {useAppState, ToggleMenu} from "@nutastic/nutastic-react-app";
import {useScrollPosition} from '@n8tb1t/use-scroll-position';

const Header = () => {
    const { navItems, headerColor = '' } = useAppState();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [ hasPastScrollThreshold, setHasPastScrollThreshold ] = useState(false);
    const componentClass = 'header';
    const classes = classnames(componentClass, {
        [`${componentClass}--isOpen`]: isMenuOpen,
        [`${componentClass}--pastTheFold`]: hasPastScrollThreshold,
        [`${componentClass}--whiteText`]: headerColor === 'white'
    });

    useScrollPosition(({ prevPos, currPos }) => {
        const { y = 0 } = currPos;
        if(y < -550){
            !hasPastScrollThreshold && setHasPastScrollThreshold(true);
        }else{
            hasPastScrollThreshold && setHasPastScrollThreshold(false);
        }
    }, [hasPastScrollThreshold]);

    const renderedLinks = Object.values(navItems || {}).map((n, i) => {
        const { href, title, new_window } = n;
        return <a key={i} href={href} target={ parseInt(new_window) ? '_blank' : '_self'} rel="noreferrer">{ title }</a>;
    });

    return <div className={classes}>
        <a href="/" className={`${componentClass}__href`}>
            <ReactSVG src="/public/assets/img/logo.svg" className={`${componentClass}__logo`} />
            <h1>LaRonda James</h1>
        </a>
        <div className={`${componentClass}__links`}>
            { renderedLinks }
        </div>
        <div className={`${componentClass}__menu-btn`} onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <i className={ isMenuOpen ? 'ion-ios-close' : 'ion-ios-menu' } />
        </div>

        <ToggleMenu
            isOpen={isMenuOpen}
            animation="slideFromRight"
            onOuterClick={() => setIsMenuOpen(false)}
        >{ renderedLinks }</ToggleMenu>
    </div>;
};

export default Header;
